import {MenuItem} from 'platform/components';

export type NavigationItem = {
  items?: NavigationItem[];
  href?: string;
  isDisabled?: boolean;
} & Omit<MenuItem, 'items'>;
